import { useState ,useEffect,useContext} from "react";
import { AppContext } from "../AppContext";

import { Routes, Route, Link } from "react-router-dom";
import ProjectHome from "./ProjectPage/ProjectHome";
import ProjectSub1 from "./ProjectPage/ProjectSub1";

import "./project.css"
export default function Project() {
  const { data } = useContext(AppContext);
  
  return (
    <div className="page page1">
      <Routes>
        <Route path="/" element={<ProjectHome />} />
        <Route path="/project/:projectId/:subId" element={<ProjectSub1 />} />
      </Routes>
    
     
      
    </div>
  );
}